import log from 'loglevel';

import type { LoggingLevel, LoggingService } from './LoggingService';

export class LogLevelLoggingService implements LoggingService {
  constructor(level: LoggingLevel = 'info') {
    log.setLevel(level);
  }

  setLevel(level: LoggingLevel) {
    return log.setLevel(level);
  }

  trace(...msg: Array<any>) {
    return log.trace(...msg);
  }

  debug(...msg: Array<any>) {
    return log.debug(...msg);
  }

  info(...msg: Array<any>) {
    return log.info(...msg);
  }

  log(...msg: Array<any>) {
    return log.info(...msg);
  }

  warn(...msg: Array<any>) {
    return log.warn(...msg);
  }

  error(...msg: Array<any>) {
    return log.error(...msg);
  }
}
